import { LoaderCircle } from 'lucide-react';
import type { HTMLAttributes } from 'react';

import { cn } from '../lib/cn';
import { Icon } from './icon';

export interface SpinnerProps extends Omit<HTMLAttributes<HTMLElement>, 'children'> {
  /** @default 'md' — sm 16 · md 20 */
  size?: 'sm' | 'md';
  /** 단독으로 쓸 때 읽히는 이름. @default '불러오는 중' */
  label?: string;
  /** 버튼처럼 바깥이 `aria-busy`를 쥐는 자리에서는 스스로 알리지 않는다. */
  decorative?: boolean;
}

/**
 * 누른 뒤 기다리는 자리의 회전 링 — 목록·카드 로딩은 `Skeleton`이다.
 * 회전 0.8s linear, reduced-motion이면 opacity 펄스(base.css `.lf-spinner`).
 */
export function Spinner({
  size = 'md',
  label = '불러오는 중',
  decorative = false,
  className,
  ...props
}: SpinnerProps) {
  const ring = <Icon as={LoaderCircle} size={size} className="lf-spinner" />;

  if (decorative) {
    return (
      <span aria-hidden="true" className={cn('inline-flex', className)} {...props}>
        {ring}
      </span>
    );
  }

  return (
    <output className={cn('inline-flex', className)} {...props}>
      {ring}
      <span className="sr-only">{label}</span>
    </output>
  );
}
